import { render } from "./DepositFormTnm.vue?vue&type=template&id=89940d88&scoped=true"
import script from "./DepositFormTnm.vue?vue&type=script&lang=js"
export * from "./DepositFormTnm.vue?vue&type=script&lang=js"

import "./DepositFormTnm.vue?vue&type=style&index=0&id=89940d88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89940d88"]])

export default __exports__